import { DriversStadingVariants } from './drivers-standings';
import { IDriverSessionDetail } from './session';

export type RaceSessionType =
  | 'FP1'
  | 'FP2'
  | 'FP3'
  | 'FP4'
  | 'G'
  | 'GS'
  | 'Q'
  | 'Q1'
  | 'Q2'
  | 'Q3'
  | 'QS'
  | 'R'
  | 'R1'
  | 'R2'
  | 'SPRINT'
  | 'SS'
  | 'SS1'
  | 'SS2'
  | 'SS3'
  | 'W';

export const FREE_PRACTICE_ONE: RaceSessionType = 'FP1';
export const FREE_PRACTICE_TWO: RaceSessionType = 'FP2';
export const FREE_PRACTICE_THREE: RaceSessionType = 'FP3';
export const FREE_PRACTICE_FOUR: RaceSessionType = 'FP4';
export const QUALIFYING_GROUP: RaceSessionType = 'Q';
export const QUALIFYING_ONE: RaceSessionType = 'Q1';
export const QUALIFYING_TWO: RaceSessionType = 'Q2';
export const QUALIFYING_THREE: RaceSessionType = 'Q3';
export const QUALIFYING_SPRINT: RaceSessionType = 'QS';
export const RACE_SPRINT: RaceSessionType = 'SPRINT';
export const RACE: RaceSessionType = 'R';
export const RACE_ONE: RaceSessionType = 'R1';
export const RACE_TWO: RaceSessionType = 'R2';
export const SHOOTOUT_SPRINT_GROUP: RaceSessionType = 'SS';
export const SHOOTOUT_SPRINT_ONE: RaceSessionType = 'SS1';
export const SHOOTOUT_SPRINT_TWO: RaceSessionType = 'SS2';
export const SHOOTOUT_SPRINT_THREE: RaceSessionType = 'SS3';
export const STARTING_GRID_SPRINT: RaceSessionType = 'GS';
export const STARTING_GRID: RaceSessionType = 'G';
export const WARMUP: RaceSessionType = 'W';

export const RACE_STATUS_FIXTURE: RaceSessionStatus = 'Fixture';
export const RACE_STATUS_PLAYING: RaceSessionStatus = 'Playing';
export const RACE_STATUS_PLAYED: RaceSessionStatus = 'Played';
export const RACE_STATUS_CANCELLED: RaceSessionStatus = 'Cancelled';
export const RACE_STATUS_POSTPONED: RaceSessionStatus = 'Postponed';
export const RACE_STATUS_SUSPENDED: RaceSessionStatus = 'Suspended';

export const DRIVERS_STANDING_TOTAL_POINTS: DriversStadingVariants = 'total-points';
export const DRIVERS_STANDING_FREE_PRACTICE_RESULTS: DriversStadingVariants = 'free-practice-results';
export const DRIVERS_STANDING_QUALIFYING_RESULTS: DriversStadingVariants = 'qualifying-results';
export const DRIVERS_STANDING_RACE_STARTING_GRID: DriversStadingVariants = 'race-starting-grid';
export const DRIVERS_STANDING_RACE_RESULTS: DriversStadingVariants = 'race-results';

export type RaceSessionStatus = 'Fixture' | 'Playing' | 'Played' | 'Cancelled' | 'Postponed' | 'Suspended';

export interface IResults extends Omit<IDriverSessionDetail, 'status' | 'team'> {
  teamName: string;
  flagUrl?: string;
  customDriverPageUrl?: string;
}